import { Card, styled } from "@mui/material";

export const CardStyled = styled(Card)(
  ({ theme: { spacing, palette, breakpoints } }) => ({
    "& .card-header": {
      padding: spacing(3),
    },
    "& .card-content": {
      paddingTop: 0,
      "&:last-child": {
        paddingBottom: spacing(3),
      },
      "& .steps-container": {
        [`${breakpoints.down("lg")}`]: {
          overflow: "auto",
          padding: spacing(2),
          "& .steps": {
            minWidth: 1200,
          },
        },
      },
    },
    "& .step": {
      transition: "0.5s all",
      border: `2px solid ${palette.common.white}`,
      background: palette.main[50],
      boxShadow: `0 0 0 2px ${palette.main[400]}`,
      "&:hover": {
        background: palette.main[100],
      },
      "&.clicked": {
        border: `2px solid ${palette.main[50]}`,
        boxShadow: "none",
        "&:hover": {
          border: `2px solid ${palette.main[100]}`,
        },
      },
      "&.active": {
        boxShadow: `0 0 0 1px ${palette.main[400]}`,
        "& .MuiTypography-body2": {
          color: palette.main[400],
        },
      },
      "&.disabled": {
        opacity: 0.6,
        cursor: "not-allowed",
        "&:hover": {
          background: palette.main[50],
        },
      },
      "& .MuiCardContent-root": {
        padding: "12px 16px",
      },
      "& .MuiTypography-body1": {
        fontSize: "14px",
        textTransform: "uppercase",
        color: palette.main[400],
      },
      "& .MuiTypography-body2": {
        fontSize: "14px",
        lineHeight: "19.6px",
        color: "#000000DE",
        wordWrap: "break-word",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
      },
    },
    "& .dot": {
      background: palette.main[100],
      borderRadius: "50%",
      width: 5,
      height: 5,
      "&.active": {
        background: palette.main[400],
      },
    },
    "& .MuiCardActionArea-root": {
      "&:hover": {
        "& .MuiCardActionArea-focusHighlight": {
          opacity: 0,
        },
      },
    },
    "& .detail": {
      "& .MuiTypography-root": {
        fontSize: "16px",
        fontWeight: 400,
      },
      "& ul": {
        marginTop: spacing(1),
        marginBottom: 0,
        paddingLeft: spacing(3),
        "& li": {
          fontSize: "14px",
          lineHeight: "16.8px",
          fontWeight: 400,
          paddingTop: spacing(1),
        },
      },
    },
    "& .MuiDivider-root": {
      borderColor: palette.main[100],
    },
  }),
);
